import ApplicationForm from "./ApplicationForm";
import Culture from "@/module/main/page/CultureEnum";
import CultureEnum from "@/module/main/page/CultureEnum";
import Currency from "@/module/main/dto/Currency";
import CurrencyCode from "@/module/main/dto/CurrencyCodeEnum";
import CurrencySymbol from "@/module/main/dto/CurrencySymbolEnum";
import IApplicationForm from "./IApplicationForm";
import {GeneratorService} from "@/app";
import ILoan from "@/module/main/model/applicationForm/ILoan";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import Loan from "@/module/main/model/applicationForm/Loan";
import IBlock1 from "@/module/main/model/applicationForm/IBlock1";
import Block1 from "@/module/main/model/applicationForm/Block1";
import IBlock3Address from "@/module/main/model/applicationForm/IBlock3Address";
import Block3Address from "@/module/main/model/applicationForm/Block3Address";
import Generator from "@/app/service/Generator";
import OrderItem from "@/module/main/model/applicationForm/OrderItem";
import ClientType from "@/module/main/dto/ClientTypeEnum";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import ICustomer from "@/module/main/model/applicationForm/ICustomer";
import Customer from "@/module/main/model/applicationForm/Customer";
import Block2Income from "@/module/main/model/applicationForm/Block2Income";
import Block2Others from "@/module/main/model/applicationForm/Block2Others";
import Block3Others from "@/module/main/model/applicationForm/Block3Others";
import Block3Employee from "@/module/main/model/applicationForm/Block3Employee";
import Block3Entrepreneur from "@/module/main/model/applicationForm/Block3Entrepreneur";
import Broker from "@/module/main/model/applicationForm/Broker";
import IOrderItem from "@/module/main/model/applicationForm/IOrderItem";
import FinancingType from "@/module/main/dto/FinancingTypeEnum";
import IBroker from "@/module/main/model/applicationForm/IBroker";
import Address from "@/module/main/model/applicationForm/Address";
import IEndpoints from "@/module/main/model/applicationForm/IEndpoints";
import Endpoints from "@/module/main/model/applicationForm/Endpoints";
import EnvType from "@/module/main/page/EnvTypeEnum";
import {IEnvSettings} from "@/module/main";
import EnvSettings from "@/module/main/model/applicationForm/EnvSettings";
import IEntrepreneur from "@/module/main/model/applicationForm/IEntrepreneur";
import Entrepreneur from "@/module/main/model/applicationForm/Entrepreneur";
import CashFinancingType from "@/module/main/dto/CashFinancingTypeEnum";
import PlatformUsedType from "@/module/main/dto/financing-v3/PlatformUsedTypeEnum";
import YesNo from "@/app/service/YesNoEnum";

class ApplicationFactory
{
    public getTemplate(culture: Culture): IApplicationForm
    {
        return this.getBaseApplicationForm(culture);
    }

    public getCustomer(culture: Culture, financedSubjectType: FinancedSubjectType = FinancedSubjectType.CASH,
                       orderType: OrderType = OrderType.STANDARD, clientType: ClientType = ClientType.PERSON): ICustomer
    {
        let orderItems: IOrderItem[] = [];
        if (financedSubjectType === FinancedSubjectType.ORDER && orderType === OrderType.STANDARD || financedSubjectType === FinancedSubjectType.WALLET)
        {
            let item = new OrderItem("AIP6S32SG", "iPhone 6s 32GB SpaceGray", "PHYSICAL",
                "Apple", 1, "24000", "image");
            orderItems.push(item);
        }

        let broker: IBroker | undefined = undefined;
        if (financedSubjectType === FinancedSubjectType.ORDER && orderType === OrderType.BROKERED)
        {
            broker = new Broker("Titanový eshop");
        }

        let block3Address: IBlock3Address = (financedSubjectType === FinancedSubjectType.ORDER && orderType !== OrderType.BROKERED)
            || financedSubjectType === FinancedSubjectType.WALLET
            ? this.getBlock3Address(culture, financedSubjectType) : new Block3Address();

        return new Customer(this.getBlock1(culture, financedSubjectType, orderType),
            new Block2Income(),
            new Block2Others(),
            new Block3Others(),
            block3Address,
            new Block3Employee(),
            new Block3Entrepreneur(),
            orderItems,
            financedSubjectType,
            orderType,
            clientType,
            broker,
            this.getEntrepreneur(culture, financedSubjectType, clientType));
    }

    public getLoan(culture: Culture, financedSubjectType: FinancedSubjectType = FinancedSubjectType.CASH,
        clientType: ClientType = ClientType.PERSON, orderType: OrderType = OrderType.STANDARD,
        financingType: FinancingType = FinancingType.INSTALLMENT, cashFinancingType: CashFinancingType = CashFinancingType.LOAN_WALLET,
        walletWithOrder: YesNo = YesNo.NO): ILoan
    {
        let loan: ILoan = new Loan();
        loan.financedSubjectType = financedSubjectType;
        loan.clientType = this.getClientType(financedSubjectType, clientType);
        loan.orderType = orderType;
        loan.financingType = financingType;
        loan.cashFinancingType = cashFinancingType;
        loan.walletWithOrder = walletWithOrder;

        switch (financedSubjectType)
        {
            case FinancedSubjectType.ORDER:
                switch (orderType)
                {
                    case OrderType.OPERATING_LEASE:
                        switch (clientType)
                        {
                            case ClientType.PERSON:
                                loan.productCode = culture === CultureEnum.CZ ? "OL01" : "OL24";
                                break;
                            case ClientType.ENTREPRENEUR:
                                loan.productCode = "OLFOP24";
                                break;
                            case ClientType.LEGAL_ENTITY:
                                loan.productCode = "OLPO24";
                                break;
                        }

                        switch (culture)
                        {
                            case CultureEnum.CZ:
                                loan.totalPrice = "27490";
                                break;

                            case CultureEnum.SK:
                                loan.totalPrice = "1239,90";
                        }
                        break;

                    default:
                        switch (clientType)
                        {
                            case ClientType.PERSON:
                                switch (culture)
                                {
                                    case CultureEnum.CZ:
                                        loan.totalPrice = "10000";
                                        loan.preferredInstallment = "987";
                                        loan.preferredDownPayment = "1000";
                                        loan.productCode = "COC2NL08";
                                        loan.productSetCode = "COCHCONL";
                                        break;

                                    case CultureEnum.SK:
                                        loan.totalPrice = "603,80";
                                        loan.preferredInstallment = "51,05";
                                        loan.preferredDownPayment = "40";
                                        loan.productCode = "COCON12A";
                                        loan.productSetCode = "COC2NL08";
                                }
                                break;

                            default:
                                loan.productCode = "COC2NL15";
                                loan.productSetCode = "HCONL1072";
                                switch (culture)
                                {
                                    case CultureEnum.CZ:
                                        loan.totalPrice = "100000";
                                        loan.preferredInstallment = "987";
                                        loan.preferredDownPayment = "10000";
                                        break;

                                    case CultureEnum.SK:
                                        loan.totalPrice = "603,80";
                                        loan.preferredInstallment = "51,05";
                                        loan.preferredDownPayment = "40";
                                }
                        }
                        break;
                }
                loan.orderNumber = Generator.getOrderNumber();
                break;

            case FinancedSubjectType.CASH:
                switch (clientType) {
                    case ClientType.PERSON:
                        switch (culture)
                        {
                            case CultureEnum.CZ:
                                switch (cashFinancingType) {
                                    case CashFinancingType.LOAN_WALLET:
                                        loan.totalPrice = "30000";
                                        loan.preferredInstallment = "3500";
                                        loan.productCode = "24FL30A03";
                                        break;
                                    case CashFinancingType.CASH_LOAN:
                                        loan.totalPrice = "12000";
                                        loan.preferredInstallment = "";
                                        loan.productCode = "";
                                        break;
                                }
                                break;
                            case CultureEnum.SK:
                                switch (cashFinancingType) {
                                    case CashFinancingType.LOAN_WALLET:
                                        loan.totalPrice = "1000";
                                        loan.preferredInstallment = "100";
                                        loan.productCode = "13FL100B2";
                                        break;
                                    case CashFinancingType.CASH_LOAN:
                                        loan.totalPrice = "500";
                                        loan.preferredInstallment = "";
                                        loan.productCode = "";
                                        break;
                                }
                                break;
                        }
                        break;

                    case ClientType.ENTREPRENEUR:
                        switch (culture)
                        {
                            case CultureEnum.CZ:
                                switch (cashFinancingType){
                                    case CashFinancingType.LOAN_WALLET:
                                        loan.totalPrice = "70000";
                                        loan.preferredInstallment = "2000";
                                        loan.productCode = "72PF70A01";
                                        break;
                                    case CashFinancingType.CASH_LOAN:
                                        loan.totalPrice = " 600000";
                                        loan.preferredInstallment = "9000";
                                        loan.productCode = "84OHU5A02";
                                        break;
                                }
                                break;
                            case CultureEnum.SK:
                                loan.totalPrice = "2000";
                                loan.preferredInstallment = "140";
                                loan.productCode = "61PF200A3";
                                break;
                        }
                        break;
                }
                break;

            case FinancedSubjectType.LIABILITY:
                switch (culture)
                {
                    case CultureEnum.CZ:
                        loan.totalPrice = "450000";
                        loan.preferredInstallment = "6765";
                        loan.productCode = "96OBL301K";
                        break;
                    case CultureEnum.SK:
                        loan.totalPrice = "3000";
                        loan.preferredInstallment = "74.23";
                        loan.productCode = "48EKO101M";
                        break;
                }
                break;

            case FinancedSubjectType.WALLET:
                switch (culture)
                {
                    case CultureEnum.CZ:
                        loan.totalPrice = "10000";
                        break;
                    case CultureEnum.SK:
                        loan.totalPrice = "500";
                        break;
                }
                loan.orderNumber = Generator.getOrderNumber();
                break;
        }

        return loan;
    }

    public getBlock1(culture: Culture, financedSubjectType: FinancedSubjectType = FinancedSubjectType.CASH,
        orderType: OrderType = OrderType.STANDARD): IBlock1
    {
        let block1 = new Block1({});

        if (financedSubjectType === FinancedSubjectType.ORDER && orderType === OrderType.BROKERED)
            return block1;

        if (financedSubjectType !== FinancedSubjectType.ORDER && financedSubjectType !== FinancedSubjectType.WALLET)
        {
            block1.identificationNumber = GeneratorService.getRandomIdent();
        }

        switch (culture)
        {
            case CultureEnum.CZ:
                block1.firstName = "Karel";
                block1.lastName = "Gott";
                block1.email = ApplicationFactory.addIdentificationNumberToEmail("karel@devnull.homecredit.cz", block1.identificationNumber);
                block1.phone = GeneratorService.getRandomPhoneNumber(culture);
                break;

            case CultureEnum.SK:
                block1.firstName = "Paľo";
                block1.lastName = "Habera";
                block1.email = ApplicationFactory.addIdentificationNumberToEmail("palo@devnull.homecredit.cz", block1.identificationNumber);
                block1.phone = GeneratorService.getRandomPhoneNumber(culture);
                break;
        }

        if (financedSubjectType === FinancedSubjectType.WALLET)
        {
            block1.platformUsed = PlatformUsedType.WEB;
        }

        return block1;
    }

    public getBlock3Address(culture: Culture, financedSubjectType: FinancedSubjectType = FinancedSubjectType.CASH): IBlock3Address
    {
        let block3Address;

        if (culture === CultureEnum.CZ)
        {
            block3Address = new Block3Address(new Address("Brno", "CZ", "Veselá",
                "237/37", "60200"), undefined, "false");
        } else
        {
            block3Address = new Block3Address(new Address("Bratislava", "SK", "Adámiho",
                "237/4A", "84105"), undefined, "false");
        }

        return block3Address;
    }

    public getEndpoints(envType: EnvType, env: string): IEndpoints
    {
        let endpoints: IEndpoints = new Endpoints({
            approvedRedirect: "https://loki.hccs.cz/acceptedApplication",
            rejectedRedirect: "https://loki.hccs.cz/rejectedApplication",
            notificationEndpoint: this.getNotificationEndpoint(envType, env),
            sourceId: "Loki_1A"
        });
        endpoints.callMeEndpoint = endpoints.notificationEndpoint;

        return endpoints;
    }

    public getEntrepreneur(culture: Culture, financedSubjectType: FinancedSubjectType = FinancedSubjectType.CASH,
                                         clientType: ClientType = ClientType.PERSON): IEntrepreneur
    {
        let entrepreneur = new Entrepreneur();

        if (financedSubjectType === FinancedSubjectType.ORDER && clientType !== ClientType.PERSON)
        {
            switch (culture)
            {
                case CultureEnum.CZ:
                    entrepreneur.representativeFirstName = "Karel";
                    entrepreneur.representativeLastName = "Gott";
                    entrepreneur.email = ApplicationFactory.addIdentificationNumberToEmail("karel@devnull.homecredit.cz");
                    entrepreneur.phone = GeneratorService.getRandomPhoneNumber(culture);
                    break;

                case CultureEnum.SK:
                    entrepreneur.representativeFirstName = "Paľo";
                    entrepreneur.representativeLastName = "Habera";
                    entrepreneur.email = ApplicationFactory.addIdentificationNumberToEmail("palo@devnull.homecredit.cz");
                    entrepreneur.phone = GeneratorService.getRandomPhoneNumber(culture);
                    break;
            }
        }

        return entrepreneur;
    }

    private getBaseApplicationForm(culture: Culture): IApplicationForm
    {
        let application: IApplicationForm = new ApplicationForm();
        application.culture = culture;
        application.currency = culture == CultureEnum.CZ
            ? new Currency(CurrencyCode.CZK, CurrencySymbol.CZK)
            : new Currency(CurrencyCode.EUR, CurrencySymbol.EUR);

        application.envSettings = this.getEnvSettings(culture);
        application.endpoints = this.getEndpoints(application.envSettings.envType, application.envSettings.env);
        application.loan = this.getLoan(application.culture);
        application.customer = this.getCustomer(culture);

        return application;
    }

    private getEnvSettings(culture: Culture): IEnvSettings
    {
        return new EnvSettings({
            env: culture == CultureEnum.CZ ? "cz10d1" : "sk10d1"
        });
    }

    private getNotificationEndpoint(envType: EnvType, env: string)
    {
        return envType === EnvType.TEST
            ? `https://app-flow-${env}.dev.cs.infra/rest/v1/applications/notifications`
            : "";
    }

    private getClientType(financedSubjectType: FinancedSubjectType, clientType: ClientType): ClientType
    {
        if (financedSubjectType === FinancedSubjectType.CASH && clientType === ClientType.LEGAL_ENTITY)
            return ClientType.ENTREPRENEUR;

        if (financedSubjectType === FinancedSubjectType.LIABILITY && clientType !== ClientType.PERSON)
            return ClientType.PERSON;

        return clientType;
    }

    private static addIdentificationNumberToEmail(email: string, identificationNumber?: string): string
    {
        let identToReplace = !!identificationNumber ? identificationNumber : GeneratorService.getRandomIdent();

        return `${identToReplace.replace(/\//, "")}.${email}`;
    }
}

export default new ApplicationFactory();
